// extracted by mini-css-extract-plugin
module.exports = {"input":"linkStyles_input__1tPRN","inputInvalid":"linkStyles_inputInvalid__2HRo7","link":"linkStyles_link__3tNZp"};